import axios from '@core_utils/api/_axios.js'

const action_plan = {
    namespaced: true,
    state: {
        corrective_list : [
            // {
            //     campaign_id : 186,
            //     ev_id: '100002513',
            //     category1_name: '환경',
            //     category2_name: '환경경영시스템',
            //     category3_name: '환경정책',
            //     reverse_name: '환경경영 정책, 방침 또는 규정을 수립하지 않음',
            //     ap_description: '국제 ESG 주요 평가 기관은 다음과 같은 영역에 대한 환경 관리 정책을 요구하고 있음 <br>- 생산 활동 및 시설/제품 및 서비스/유통 및 물류/폐기물 관리/공급망',
            //     risk_lv : 'high',
            //     has_plan: true
            // },
        ]
    },
    getters: {},
    mutations: {
        update_action_plan_auto(state, new_arr){
            state.corrective_list = !new_arr || !new_arr.length ? [] : new_arr
        }
    },
    actions: {
        async readActionPlanAuto ({ commit }, { project_code, company_id, campaign_id }) {
            commit('update_action_plan_auto', []) 
            const response = await axios.get('/read_action_plan_auto', {
                params: { project_code, company_id, campaign_id }
            })
            commit('update_action_plan_auto', response.data.cat2_data) 
        }
    }
}
export default action_plan
